import * as React from "react";
import {
  container,
  hotelName,
  freeStay,
  folioRequest,
} from "./ReservationCard.module.scss";
import Button from "react-bootstrap/Button";
import { IFolioButtonProps } from "./ReservationCardProps";

export const Container: React.FC<any> = (props) => {
  return <div className={`${container} reservationCard`}>{props.children}</div>;
};

export const HotelName: React.FC<any> = (props) => {
  return <h4 className={`${hotelName} mb-2`}>{props.children}</h4>;
};

export const FreeStay: React.FC = () => {
  return <span className={freeStay}>FREE STAY</span>;
};

export const RequestFolioButton: React.FC<IFolioButtonProps> = (props) => {
  const handleShowFolioModal = () => {
    props.showFolioModal(true);
  };
  return (
    <div className={folioRequest}>
      <Button
        variant="link"
        size="sm"
        className="request-folio-button"
        onClick={handleShowFolioModal}
      >
        Request Folio
      </Button>
    </div>
  );
};
